module.exports = __webpack_public_path__ + "static/media/0023_LES_ENSEIGNES_LE_CHARCUTIER_LETTRE_A_LETTRE.e44aec38.png";